import { BuildTierData } from '../types';

export const buildTierSuggestion: BuildTierData[] = [
  {
    option: 1,
    name: 'Casual Use'
  },
  {
    option: 2,
    name: 'Productivity & Gaming use'
  },
  {
    option: 3,
    name: 'Performance Use'
  }
];
